webpackJsonp([1],Array(32).concat([
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)
__webpack_require__(136)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-24e0711e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var axios = __webpack_require__(34);
var apiUrl = __webpack_require__.i({"NODE_ENV":"production"}).API_URL || '/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
  getIdeas: function getIdeas(ideasData, cb, errorCb) {
    axios.get(apiUrl + 'ideas', ideasData).then(function (response) {
      cb(response.data);
    }).catch(function (error) {
      errorCb(error.message);
    });
  },
  storeIdea: function storeIdea(ideaData, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'ideas', ideaData).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  updateIdea: function updateIdea(ideaData, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'ideas/' + ideaData._id, ideaData).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  deleteIdea: function deleteIdea(ideaId, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'ideas/' + ideaId + '/delete').then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  storeList: function storeList(listData, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'lists', listData).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  claimList: function claimList(data, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'lists/' + data.list._id + '/claim', data).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  storeIdeaOnList: function storeIdeaOnList(data, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'lists/' + data.list._id + '/ideas', data).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  updateIdeaOnList: function updateIdeaOnList(listId, ideaId, data, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'lists/' + listId + '/ideas/' + ideaId, data).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  deleteIdeaOnList: function deleteIdeaOnList(data, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'lists/' + data.list._id + '/ideas/' + data.ideaId + '/delete', data).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  updateList: function updateList(listData, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.post(apiUrl + 'lists/' + listData._id, listData).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  getList: function getList(listData, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.get(apiUrl + 'lists/' + listData.slug, listData).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  },
  getLists: function getLists(listData, cb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      axios.get(apiUrl + 'lists', listData).then(function (response) {
        cb(response.data);
        resolve();
      }).catch(function (error) {
        errorCb(error.message);
      });
    });
  }
});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_AllPage__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_AllPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_AllPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ListPage__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_CreatePage__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_CreatePage__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'all',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_AllPage___default.a
  }, {
    path: '/create',
    name: 'create',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_CreatePage___default.a
  }, {
    path: '/:slug',
    name: 'list',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_ListPage___default.a
  }]
}));

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ideas__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lists__ = __webpack_require__(85);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* default */]);

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist___default.a({
  key: 'vuex',
  storage: window.localStorage });

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* default */].Store({
  modules: {
    ideas: __WEBPACK_IMPORTED_MODULE_3__ideas__["a" /* default */],
    lists: __WEBPACK_IMPORTED_MODULE_4__lists__["a" /* default */]
  },
  plugins: [vuexLocalStorage.plugin]
}));

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_agile__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_agile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_agile__);









__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_agile___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(40);




var state = {
  ideas: [],
  newestIdea: null
};

var actions = {
  getIdeas: function getIdeas(_ref, ideasData) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getIdeas(ideasData, function (ideas) {
                commit('indexIdeas', ideas);
              }, function (error) {
                console.log('could not pull list of ideas');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  storeIdea: function storeIdea(_ref2, ideaData) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].storeIdea(ideaData, function (idea) {
                commit('createIdea', idea);
              }, function (error) {
                console.log('could not add that new idea');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  updateIdea: function updateIdea(_ref3, ideaData) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateIdea(ideaData, function (idea) {
                console.log('updated idea', idea);
                commit('editIdea', idea);
              }, function (error) {
                console.log('could not update that idea');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  deleteIdea: function deleteIdea(_ref4, ideaId) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteIdea(ideaId, function (response) {
                console.log(response);
                commit('removeIdea', ideaId);
              }, function (error) {
                console.log('could not delete that idea');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
};

var mutations = {
  indexIdeas: function indexIdeas(state, ideas) {
    state.ideas = ideas;
  },
  createIdea: function createIdea(state, idea) {
    state.ideas.unshift(idea);
    state.newestIdea = idea;
  },
  editIdea: function editIdea(state, idea) {
    state.ideas = state.ideas.filter(function (eachIdea) {
      return eachIdea._id !== idea._id;
    });
    state.ideas.unshift(idea);
  },
  removeIdea: function removeIdea(state, ideaId) {
    state.ideas = state.ideas.filter(function (eachIdea) {
      return eachIdea._id !== ideaId;
    });
  }
};

var getters = {
  ideas: function ideas(state) {
    return state.ideas;
  },
  newestIdea: function newestIdea(state) {
    return state.newestIdea;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(40);




var state = {
  lists: [],
  list: null
};

var actions = {
  getLists: function getLists(_ref, listsData) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getLists(listsData, function (lists) {
                commit('indexLists', lists);
              }, function (error) {
                console.log('could not pull the lists');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  storeList: function storeList(_ref2, listData) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].storeList(listData, function (list) {
                commit('createList', list);
              }, function (error) {
                console.log('could not add that new list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  submitClaimEmail: function submitClaimEmail(_ref3, data) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].claimList(data, function (list) {
                commit('updatedList', list);
              }, function (error) {
                console.log('could not claim that list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  addIdeaToList: function addIdeaToList(_ref4, data) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].storeIdeaOnList(data, function (list) {
                commit('updatedList', list);
              }, function (error) {
                console.log('could not add that to list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  updateIdeaOnList: function updateIdeaOnList(_ref5, data) {
    var _this5 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateIdeaOnList(data.listId, data.ideaId, data.data, function (list) {
                commit('updatedList', list);
              }, function (error) {
                console.log('could not update that on list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateIdeaSilently: function updateIdeaSilently(_ref6, data) {
    var _this6 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateIdeaOnList(data.listId, data.ideaId, data.data, function (list) {}, function (error) {
                console.log('could not update that on list silently');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  removeIdeaFromList: function removeIdeaFromList(_ref7, data) {
    var _this7 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteIdeaOnList(data, function (ideaId) {
                commit('removedIdeaFromList', ideaId);
              }, function (error) {
                console.log('could not remove that from list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getList: function getList(_ref8, listsData) {
    var _this8 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getList(listsData, function (lists) {
                commit('readList', lists);
              }, function (error) {
                console.log('could not pull the lists');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  updateList: function updateList(_ref9, listData) {
    var _this9 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateList(listData, function (list) {
                console.log('updated list', list);
                commit('updatedList', list);
              }, function (error) {
                console.log('could not update that list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  deleteList: function deleteList(_ref10, listId) {
    var _this10 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteList(listId, function (response) {
                commit('removeList', listId);
              }, function (error) {
                console.log('could not delete that list');
                console.log(error);
              });

            case 2:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  resetList: function resetList(_ref11, listId) {
    var _this11 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit('didResetList', listId);

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }
};

var mutations = {
  indexLists: function indexLists(state, lists) {
    state.lists = lists;
  },
  createList: function createList(state, list) {
    state.lists.unshift(list);
    state.list = list;
  },
  readList: function readList(state, list) {
    state.list = list;
  },
  updatedList: function updatedList(state, list) {
    state.lists = state.lists.filter(function (eachList) {
      return eachList._id !== list._id;
    });
    state.lists.unshift(list);

    state.list = list;
  },
  removedIdeaFromList: function removedIdeaFromList(state, ideaId) {
    state.list.ideas = state.list.ideas.filter(function (i) {
      return i.id !== ideaId;
    });
  },
  removeList: function removeList(state, listId) {
    state.lists = state.lists.filter(function (eachList) {
      return eachList._id !== listId;
    });

    state.list = null;
  },
  didResetList: function didResetList(state, listId) {
    state.list = null;
  }
};

var getters = {
  list: function list(state) {
    return state.list;
  },
  lists: function lists(state) {
    return state.lists;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      openHelp: false
    };
  },

  props: {
    listPage: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IdeaIcon__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IdeaIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_IdeaIcon__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IdeaIcon: __WEBPACK_IMPORTED_MODULE_2__components_IdeaIcon___default.a
  },
  props: {
    idea: Object,
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      editingDescription: false,
      showingImages: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['list']), {
    bgImage: function bgImage() {
      return 'background-image: url(\'' + this.image + '\')';
    },
    image: function image() {
      if (!this.idea.images || !this.idea.images.length) {
        return 'https://us.123rf.com/450wm/puruan/puruan1702/puruan170204912/72146428-pin-location-map-icon-in-metallic-gray-color-style-.jpg?ver=6';
      }
      return this.idea.images[0];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateIdeaOnList']), {
    remove: function remove() {
      if (confirm('Are you sure you want to get rid of ' + this.idea.name + '?')) {
        this.$emit('remove');
      }
    },
    showBigImages: function showBigImages() {
      if ('images' in this.idea && this.idea.images) {
        this.showingImages = true;
      }
    },
    updateDescription: function updateDescription() {
      this.updateIdeaOnList({
        data: {
          description: this.idea.description
        },
        listId: this.list._id,
        ideaId: this.idea.id
      });

      if (!this.idea.description) {
        return;
      }

      this.editingDescription = false;
    }
  })
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    idea: Object
  },
  data: function data() {
    return {
      dialog: false,
      icons: ['⭐️', '🍽', '🍷', '☕️', '🍺', '🍸', '🍳', '🍔', '🍕', '🌮', '🥩', '🥗', '🐟', '🍝', '🍣', '🍜', '🥘', '🍦', '👀', '😂', '🎉', '🏠', '🔥', '🎤', '🌲', '❤️', '💙', '💚', '💛', '💜', '🖤', '✅', '🆗', '🆒'],
      icon: '⭐️'
    };
  },
  mounted: function mounted() {
    if (this.idea.icon) {
      this.icon = this.idea.icon;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['list'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateIdeaOnList']), {
    select: function select(icon) {
      this.icon = icon;
      this.finish();
    },
    finish: function finish() {
      this.dialog = false;
      this.updateIcon();
    },
    updateIcon: function updateIcon() {
      this.updateIdeaOnList({
        data: {
          icon: this.icon
        },
        listId: this.list._id,
        ideaId: this.idea.id
      });
    }
  })
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      map: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: this.list.ideas[0].location.coordinates[1], lng: this.list.ideas[0].location.coordinates[0] },
      zoom: 12
    });

    this.list.ideas.forEach(function (idea) {
      var infowindow = new google.maps.InfoWindow({
        content: _this.getInfoWindow(idea)
      });
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(idea.location.coordinates[1], idea.location.coordinates[0]),

        label: idea.icon,
        map: _this.map
      });
      marker.addListener('click', function () {
        infowindow.open(this.map, marker);
      });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['list'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateIdeaOnList']), {
    getInfoWindow: function getInfoWindow(idea) {
      return '\n        <div class="info-window">\n          <div style="float:left; width:100px; margin-right:10px"><img style="max-width:100%" src="' + idea.image + '"></div>\n          <div style="float:right">\n            <h3 style="color:black; font-weight:bold; font-size:18px;"><strong>' + idea.name + ' &nbsp;' + (idea.icon ? idea.icon : '') + '</strong></h3>\n            <p style="font-size:14px; margin-bottom:3px;"><a target="_blank" class="no-underline-on-hover" href="' + idea.website + '">Website</a></p>\n            <p style="font-size:14px;"><a target="_blank" class="underline-on-hover" href="' + idea.url + '">' + idea.address + '</a></p>\n            ' + (idea.description ? '<p style="margin-top:6px; font-weight:bold; font-size:14px;">' + idea.description + '</p>' : '') + '\n          </div>\n        </div>\n      ';
    }
  })
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.getLists();
  },
  data: function data() {
    return {
      menuOpen: false,
      openHelp: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['lists'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getLists']))
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SiteHeader__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SiteHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SiteHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SiteHeader: __WEBPACK_IMPORTED_MODULE_1__components_SiteHeader___default.a
  },
  mounted: function mounted() {
    this.getLists();
  },
  data: function data() {
    return {
      search: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['lists'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getLists']), {
    shouldShow: function shouldShow(list) {
      if (!(list && list.name && list.ideas && list.ideas.length)) {
        return false;
      }

      if (this.search) {
        var names = (list.name + ' ' + list.description + ' ' + list.ideas.map(function (idea) {
          return idea ? idea.name : '';
        }).join(' ')).toLowerCase();
        if (!names.includes(this.search.toLowerCase())) {
          return false;
        }
      }

      return true;
    }
  })
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelpBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelpBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HelpBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_IdeaCard__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_IdeaCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_IdeaCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteHeader__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SiteHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mongoose__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mongoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mongoose__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HelpBox: __WEBPACK_IMPORTED_MODULE_2__components_HelpBox___default.a,
    IdeaCard: __WEBPACK_IMPORTED_MODULE_3__components_IdeaCard___default.a,
    SiteHeader: __WEBPACK_IMPORTED_MODULE_4__components_SiteHeader___default.a
  },
  data: function data() {
    return {
      listTitleInput: null,
      textToParse: null,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['list'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['storeList']), {
    parseLine: function parseLine(line) {
      line = line.trim();
      if (!line || line === '') {
        return null;
      }
      var possibleCommentDelimeters = ['//', '--', '::', '##'];
      var pieces = [];
      var name = null;
      var comment = null;
      var i = 0;

      while (!comment && i < possibleCommentDelimeters.length) {
        pieces = line.split(possibleCommentDelimeters[i]);
        name = pieces.shift().trim();
        if (pieces.length > 0) {
          comment = pieces.join().trim();
        }
        i++;
      }

      return { name: name, comment: comment };
    },
    lookupPlaces: function lookupPlaces() {
      var _this = this;

      if (!this.listTitleInput) {
        return;
      }
      this.loading = true;

      var parsed = this.parseLine(this.listTitleInput);

      this.storeList({ name: parsed.name, description: parsed.comment }).then(function () {
        _this.goToList();
      });
    },
    goToList: function goToList() {
      this.$router.push({ name: 'list', params: { slug: this.list.slug } });
    }
  })
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteHeader__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SiteHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HelpBox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HelpBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_HelpBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_IdeaCard__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_IdeaCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_IdeaCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MapView__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MapView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_MapView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mongoose__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mongoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mongoose__);





var asyncForEach = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(array, callback) {
    var index;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < array.length)) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return callback(array[index], index, array);

          case 4:
            index++;
            _context.next = 1;
            break;

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function asyncForEach(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HelpBox: __WEBPACK_IMPORTED_MODULE_5__components_HelpBox___default.a,
    SiteHeader: __WEBPACK_IMPORTED_MODULE_4__components_SiteHeader___default.a,
    IdeaCard: __WEBPACK_IMPORTED_MODULE_6__components_IdeaCard___default.a,
    MapView: __WEBPACK_IMPORTED_MODULE_7__components_MapView___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a
  },

  mounted: function mounted() {
    var _this = this;

    this.getList({ slug: this.$route.params.slug }).then(function () {
      if (!_this.list.ideas.length) {
        _this.$refs.pasteInput.focus();
      }
    });
  },
  data: function data() {
    return {
      toolboxOpen: false,
      isClaiming: false,
      claimEmail: null,
      sentClaimEmail: false,
      textToParse: null,
      newIdeas: [],
      loadedIdeas: 0,
      listIsLoading: false,
      openHelp: false,
      editingDescription: false,
      view: 'list'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])(['list']), {
    canClaimList: function canClaimList() {
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(['addIdeaToList', 'getList', 'removeIdeaFromList', 'submitClaimEmail', 'updateIdeaOnList', 'updateIdeaSilently', 'updateList']), {
    changeDay: function changeDay(addDays) {
      var newIndex = this.currentDayIndex + addDays;
      if (newIndex < 0) {
        this.currentDayIndex = 0;
      } else if (newIndex >= this.days.length) {
        this.currentDayIndex = this.days.length - 1;
      } else {
        this.currentDayIndex = newIndex;
      }
    },
    removeIdea: function removeIdea(ideaId) {
      this.removeIdeaFromList({ list: this.list, ideaId: ideaId });
    },
    sendClaimEmail: function sendClaimEmail() {
      this.sentClaimEmail = true;
      this.submitClaimEmail({ list: this.list, email: this.claimEmail });
    },
    parseLine: function parseLine(line) {
      line = line.trim();
      if (!line || line === '') {
        return null;
      }
      var possibleCommentDelimeters = ['//', '--', '::', '##'];
      var pieces = [];
      var name = null;
      var comment = null;
      var i = 0;

      while (!comment && i < possibleCommentDelimeters.length) {
        pieces = line.split(possibleCommentDelimeters[i]);
        name = pieces.shift().trim();
        if (pieces.length > 0) {
          comment = pieces.join().trim();
        }
        i++;
      }

      return { name: name, comment: comment };
    },
    createIdeaFromText: function createIdeaFromText(index, listLine) {
      return {
        _id: index,
        name: listLine.name,
        fromApi: false,
        description: listLine.comment,
        image: null
      };
    },
    clearList: function clearList() {
      this.newIdeas = [];
      this.listIsLoading = false;
    },
    renderList: function renderList() {
      var _this2 = this;

      this.clearList();

      var parsed = null;

      if (!this.textToParse) {
        return;
      }
      var lines = this.textToParse.split('\n');
      lines.forEach(function (line, index) {
        parsed = _this2.parseLine(line);
        if (!parsed) {
          return;
        }
        _this2.newIdeas.push(_this2.createIdeaFromText(index, parsed));
      });
    },
    lookupPlaces: function lookupPlaces() {
      var _this3 = this;

      if (!this.newIdeas) {
        return;
      }

      var placeId = null;
      var place = null;
      var newIdea = null;
      var updatedList = null;

      this.listIsLoading = true;
      this.loadedIdeas = 0;

      var startTime = Date.now();
      var time = -2000;

      this.newIdeas.forEach(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(idea, index) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3.listIsLoading = true;
                  _context3.next = 3;
                  return setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this3.listIsLoading = true;
                            _context2.next = 3;
                            return _this3.lookupPlaceId(idea);

                          case 3:
                            placeId = _context2.sent;
                            _context2.next = 6;
                            return _this3.getPlaceDetails(placeId);

                          case 6:
                            place = _context2.sent;

                            newIdea = _this3.replaceWithApiVersion(place, index);
                            _context2.next = 10;
                            return _this3.addIdeaToList({ idea: newIdea, list: _this3.list });

                          case 10:
                            updatedList = _context2.sent;

                            _this3.replacePhotos(newIdea);
                            _this3.listIsLoading = false;
                            _this3.loadedIdeas++;

                          case 14:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  })), time += 2000);

                case 3:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this3);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    lookupPlaceId: function lookupPlaceId(idea) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
          var request, placesService;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  request = {
                    query: idea.name + ' ' + _this4.list.name,
                    fields: ['name', 'place_id']
                  };
                  placesService = new google.maps.places.PlacesService(document.getElementById('place-results'));

                  placesService.findPlaceFromQuery(request, function (results, status) {
                    if (status === google.maps.places.PlacesServiceStatus.OK && results.length) {
                      resolve(results[0].place_id);
                    } else {
                      reject(status);
                    }
                  });
                  _context4.next = 9;
                  break;

                case 6:
                  _context4.prev = 6;
                  _context4.t0 = _context4['catch'](0);
                  return _context4.abrupt('return', reject(_context4.t0));

                case 9:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this4, [[0, 6]]);
        })), 500);
      });
    },
    getPlaceDetails: function getPlaceDetails(placeId) {
      var fields = ['name', 'url', 'website', 'photos', 'vicinity', 'price_level', 'geometry', 'formatted_address'];
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _this5 = this;

        setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
          var placesService;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  placesService = new google.maps.places.PlacesService(document.getElementById('place-results'));

                  placesService.getDetails({ placeId: placeId, fields: fields }, function (place, status) {
                    if (status == google.maps.places.PlacesServiceStatus.OK) {
                      resolve(place);
                    } else {
                      reject(status);
                    }
                  });
                  _context5.next = 8;
                  break;

                case 5:
                  _context5.prev = 5;
                  _context5.t0 = _context5['catch'](0);
                  return _context5.abrupt('return', reject(_context5.t0));

                case 8:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this5, [[0, 5]]);
        })), 500);
      });
    },
    replaceWithApiVersion: function replaceWithApiVersion(place, index) {
      var idea = {
        id: __WEBPACK_IMPORTED_MODULE_11_mongoose___default.a.Types.ObjectId().toString(),
        place_id: place.placeId,
        name: place.name,
        favorite: true,
        slot: null,
        day: null,
        icon: '⭐️',
        image: place.photos && place.photos.length ? place.photos[0].getUrl({ 'maxWidth': 200, 'maxHeight': 200 }) : null,
        images: [],
        url: place.url,
        address: place.vicinity,
        website: place.website,
        description: this.newIdeas[index].description,
        location: {
          type: 'Point',
          coordinates: [place.geometry.location.lng(), place.geometry.location.lat()],
          address: place.formatted_address
        }
      };

      if (place.photos && place.photos.length) {
        place.photos.forEach(function (photo) {
          idea.images.push(photo.getUrl({ 'maxWidth': 400, 'maxHeight': 400 }));
        });
      }

      return idea;
    },
    replacePhotos: function replacePhotos(idea) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                asyncForEach(idea.images, function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(url, index) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return _this6.uploadToCloudinary(url, index, idea);

                          case 2:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this6);
                  }));

                  return function (_x5, _x6) {
                    return _ref6.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    uploadToCloudinary: function uploadToCloudinary(oldUrl, index, idea) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var cloudinary, url, formData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!oldUrl.includes('cloudinary')) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return');

              case 2:
                cloudinary = {
                  uploadPreset: 'bestspots',
                  apiKey: '247778674891827',
                  cloudName: 'thatericsmith'
                };
                url = 'https://api.cloudinary.com/v1_1/' + cloudinary.cloudName + '/upload';
                formData = new FormData();

                formData.append('file', oldUrl);
                formData.append('upload_preset', cloudinary.uploadPreset);
                formData.append('tags', 'bestspots');
                _context10.next = 10;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, formData).then(function () {
                  var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(res) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return _this7.updateImageOnIdea(idea, index, res.data.secure_url);

                          case 2:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this7);
                  }));

                  return function (_x7) {
                    return _ref7.apply(this, arguments);
                  };
                }()).catch(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return _this7.updateImageOnIdea(idea, index, null);

                        case 2:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _callee9, _this7);
                })));

              case 10:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this7);
      }))();
    },
    updateImageOnIdea: function updateImageOnIdea(idea, index, url) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                console.log(idea.name, index, url);
                idea.images[index] = url;
                _context11.next = 4;
                return _this8.updateIdeaSilently({
                  data: {
                    images: idea.images
                  },
                  listId: _this8.list._id,
                  ideaId: idea.id
                });

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this8);
      }))();
    },
    toggleView: function toggleView() {
      this.view = this.view === 'list' ? 'map' : 'list';
    },
    updateDescription: function updateDescription() {
      this.updateList({ _id: this.list._id, description: this.list.description });
      this.editingDescription = false;
    }
  }),
  watch: {
    textToParse: function textToParse() {
      this.renderList();
    },
    loadedIdeas: function loadedIdeas(newLoaded) {
      if (newLoaded > 0 && newLoaded == this.newIdeas.length) {
        this.textToParse = '';
      }
    }
  }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-4a8e220c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-cb784dd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)
__webpack_require__(141)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-a278a912",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full flex cursor-move idea-card",
    class: {
      'flex-col-reverse': _vm.showingImages
    }
  }, [(!_vm.showingImages) ? _c('div', {
    staticClass: "h-auto w-24 flex-none bg-cover rounded-t-none rounded-l text-center overflow-hidden bg-center",
    style: (_vm.bgImage),
    attrs: {
      "title": _vm.idea.name
    },
    on: {
      "click": _vm.showBigImages
    }
  }) : _c('div', {
    staticClass: "w-full idea-image-slider",
    on: {
      "click": function($event) {
        _vm.showingImages = false
      }
    }
  }, _vm._l((_vm.idea.images), function(image) {
    return _c('img', {
      staticStyle: {
        "max-width": "400px",
        "display": "inline"
      },
      attrs: {
        "src": image
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w-full border-r border-t border-gray-light bg-white rounded-r p-2 flex flex-col justify-between leading-normal",
    class: {
      'border-l rounded-l': _vm.showingImages, 'border-b': !_vm.showingImages
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removable),
      expression: "removable"
    }],
    staticClass: "close-icon text-gray-light px-2 hover:text-black",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("\n        ×\n      ")]), _vm._v(" "), _c('header', {
    staticClass: "text-black font-bold mb-1 leading-tight idea-card-header"
  }, [_vm._v("\n          " + _vm._s(_vm.idea.name) + "\n          "), _c('idea-icon', {
    attrs: {
      "idea": _vm.idea
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "3.25rem"
    }
  }, [(_vm.idea.address || _vm.idea.website) ? _c('p', {
    staticClass: "text-sm leading-tight mb-1 text-gray"
  }, [_c('a', {
    staticClass: "text-gray hover:text-gray-700 underline",
    attrs: {
      "target": "_blank",
      "href": _vm.idea.website
    }
  }, [_vm._v("Website")]), _vm._v(" "), (_vm.idea.address && _vm.idea.website) ? _c('span', [_vm._v("·")]) : _vm._e(), _vm._v(" "), (_vm.idea.address) ? _c('a', {
    staticClass: "text-gray hover:text-gray-700 no-underline hover:underline",
    attrs: {
      "target": "_blank",
      "href": _vm.idea.url
    }
  }, [_vm._v(_vm._s(_vm.idea.address))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.editingDescription) ? _c('p', {
    staticClass: "text-gray-500 text-sm leading-tight",
    staticStyle: {
      "min-height": "1rem"
    },
    on: {
      "click": function($event) {
        _vm.editingDescription = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.idea.description) + "\n        ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idea.description),
      expression: "idea.description"
    }],
    ref: "description",
    staticClass: "input-description w-full text-sm",
    domProps: {
      "value": (_vm.idea.description)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateDescription.apply(null, arguments)
      },
      "blur": _vm.updateDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idea, "description", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "map"
    }
  })])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header cursor-pointer flex justify-between items-center"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('strong', [_c('a', {
    staticClass: "text-gray-700 no-underline",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/')
      }
    }
  }, [_c('span', {
    staticClass: "color-logo-1"
  }, [_vm._v("best")]), _vm._v(" "), _c('span', {
    staticClass: "color-logo-2"
  }, [_vm._v("spots")])])])]), _vm._v(" "), _c('button', {
    staticClass: "bg-blue-400 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/create')
      }
    }
  }, [_vm._v("Create")])])
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "px-6 py-2 md:p-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listTitleInput),
      expression: "listTitleInput"
    }],
    staticClass: "block w-full border border-gray bg-white p-2 mb-2",
    attrs: {
      "type": "text",
      "placeholder": "Los Angeles, Kauai, etc"
    },
    domProps: {
      "value": (_vm.listTitleInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.listTitleInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.listTitleInput) ? _c('div', [_c('button', {
    staticClass: "p-2 text-xs text-white bg-indigo-700 mb-2",
    class: _vm.loading ? 'bg-indigo-100' : '',
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.lookupPlaces
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loading ? 'Creating' : 'Create') + " your list for: "), _c('strong', [_vm._v(_vm._s(_vm.listTitleInput))]), _vm._v(_vm._s(_vm.loading ? '...' : '') + "\n          ")])]) : _c('help-box')], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mb-3"
  }, [_c('p', [_c('strong', [_vm._v("Type in a city or location")])])])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('a', {
    staticClass: "text-blue-400 hover:text-blue-600",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openHelp = !_vm.openHelp
      }
    }
  }, [_vm._v(_vm._s(_vm.openHelp ? 'OK, cool' : 'What is this?'))])]), _vm._v(" "), (_vm.openHelp) ? _c('div', {
    staticClass: "mb-6"
  }, [_vm._m(0), _vm._v(" "), (!_vm.listPage) ? _c('pre', {
    staticClass: "bg-yellow-300 mb-2 p-1"
  }, [_vm._v("Dallas // Fun food & drink spots\n")]) : _vm._e(), _vm._v(" "), (_vm.listPage) ? _c('pre', {
    staticClass: "bg-yellow-300 mb-2 p-1"
  }, [_vm._v("Lucia // Crazy good Italian\nSmall Brewpub\nTrompo Tacos // Yummy simple place\nHonor Bar\nHoundstooth // Delicious coffee\n")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left w-full p-4 text-sm bg-gray-200"
  }, [_c('a', {
    staticClass: "text-blue hover:text-blue-700",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/thatericsmith"
    }
  }, [_vm._v("@thatericsmith")]), _vm._v(" and \n          "), _c('a', {
    staticClass: "text-blue hover:text-blue-700",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/jbsmith2004"
    }
  }, [_vm._v("@jbsmith2004")]), _vm._v(" made "), _c('strong', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("Best Spots")]), _vm._v(" for you."), _c('br'), _c('br'), _vm._v("\n          Come here and paste a city and a list of places that you recommend, or that friends have recommended."), _c('br'), _vm._v("We'll google each spot and give you a link so you can remember them."), _c('br'), _c('br'), _vm._v("\n          Here's an example you can paste in and try:\n        ")])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "padding": "0 4px"
    },
    on: {
      "click": function($event) {
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_vm._v("\n    " + _vm._s(this.icon) + "\n  ")]), _vm._v(" "), (_vm.dialog) ? _c('div', {
    staticClass: "icon-dialog"
  }, [_vm._l((_vm.icons), function(dialogIcon, i) {
    return _c('a', {
      key: ("icon-" + i),
      staticClass: "icon-dialog-icon",
      class: {
        'icon-active': _vm.icon == dialogIcon
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.select(dialogIcon)
        }
      }
    }, [_vm._v(_vm._s(dialogIcon))])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icon),
      expression: "icon"
    }],
    staticClass: "icon-input",
    domProps: {
      "value": (_vm.icon)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.icon = $event.target.value
      }, _vm.finish]
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('div', {
    staticClass: "main-grid"
  }, [_c('div', {
    staticClass: "px-6 py-2 md:p-6 bg-gray-100"
  }, [_c('header', {
    staticClass: "mb-3"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.editingDescription = !_vm.editingDescription
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.list ? _vm.list.name : 'Ideas'))])]), _vm._v(" "), (_vm.list && !_vm.editingDescription) ? _c('p', {
    staticClass: "color-gray-light",
    on: {
      "click": function($event) {
        _vm.editingDescription = !_vm.editingDescription
      }
    }
  }, [_vm._v(_vm._s(_vm.list.description))]) : _vm._e(), _vm._v(" "), (_vm.editingDescription) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.list.description),
      expression: "list.description"
    }],
    ref: "description",
    staticClass: "input-description w-full text-sm mb-2",
    domProps: {
      "value": (_vm.list.description)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateDescription.apply(null, arguments)
      },
      "blur": _vm.updateDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.list, "description", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canClaimList) ? _c('div', {
    staticClass: "my-2"
  }, [(_vm.sentClaimEmail) ? _c('div', [_vm._m(0)]) : _c('div', [(!_vm.isClaiming) ? _c('button', {
    staticClass: "bg-blue-400 hover:bg-blue-800 text-white font-bold py-1 px-2 text-sm rounded",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isClaiming = true
      }
    }
  }, [_vm._v("\n                Claim this list\n              ")]) : _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendClaimEmail.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimEmail),
      expression: "claimEmail"
    }],
    staticClass: "p-2 block w-full border border-gray bg-white",
    attrs: {
      "required": "",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.claimEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "block w-full bg-blue-400 hover:bg-blue-800 font-bold text-sm text-white p-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Claim via email\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "block text-center bg-gray-100 w-full p-2 text-xs text-gray my-2",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isClaiming = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.list.ideas.length) ? _c('div', [_c('button', {
    staticClass: "bg-green-400 hover:bg-green-800 text-white font-bold py-1 px-2 text-sm rounded",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleView.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              View " + _vm._s(_vm.view === 'list' ? 'on Map' : 'List') + "\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.view === 'list') ? _c('div', [_c('div', {
    staticClass: "idea-list"
  }, _vm._l((_vm.list.ideas), function(idea) {
    return _c('idea-card', {
      key: idea.id,
      attrs: {
        "data-id": idea.id,
        "idea": idea,
        "removable": true
      },
      on: {
        "remove": function($event) {
          return _vm.removeIdea(idea.id)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textToParse),
      expression: "textToParse"
    }],
    ref: "pasteInput",
    staticClass: "block w-full border border-gray bg-white p-2",
    staticStyle: {
      "min-height": "135px"
    },
    attrs: {
      "placeholder": "Paste in places..."
    },
    domProps: {
      "value": (_vm.textToParse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textToParse = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('help-box', {
    attrs: {
      "list-page": ""
    }
  }), _vm._v(" "), (_vm.textToParse) ? _c('div', [_c('button', {
    staticClass: "p-2 text-xs text-white bg-indigo-700 mb-2",
    style: (_vm.listIsLoading ? 'opacity:0.7' : ''),
    attrs: {
      "disabled": _vm.listIsLoading
    },
    on: {
      "click": _vm.lookupPlaces
    }
  }, [_vm._v("\n                " + _vm._s(_vm.listIsLoading ? 'Looking up' : 'Lookup') + " these places" + _vm._s(_vm.listIsLoading ? '...' : '') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "visible",
    attrs: {
      "id": "place-results"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.newIdeas) ? _c('div', _vm._l((_vm.newIdeas), function(newIdea, counter) {
    return _c('div', {
      key: newIdea.id,
      staticClass: "mb-1"
    }, [(counter >= _vm.loadedIdeas) ? _c('idea-card', {
      attrs: {
        "idea": newIdea
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "block text-left bg-gray-100 w-full p-1 text-xs text-gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/create')
      }
    }
  }, [_vm._v("\n                ← Create a new list\n              ")])])], 1) : _c('div', [_c('map-view')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-xs text-green"
  }, [_c('strong', [_vm._v("Sent!")]), _vm._v(" Check your email to claim this list.")])
}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: " px-6 py-2 md:p-6 bg-gray-100"
  }, [_c('header', {
    staticClass: "mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "my-1"
  }, [_c('button', {
    staticClass: "block text-left bg-gray-100 w-full p-1 text-xs text-gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/create')
      }
    }
  }, [_vm._v("\n              ← Create a new list\n            ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "block w-full border border-gray bg-white p-2 mb-2",
    attrs: {
      "type": "search",
      "placeholder": "Search cities or spots..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.lists) ? _c('div', _vm._l((_vm.lists), function(list) {
    return _c('div', {
      key: list._id
    }, [(_vm.shouldShow(list)) ? _c('div', {
      staticClass: "py-3"
    }, [_c('h3', [_c('strong', [_c('a', {
      staticClass: "text-blue-400 hover:text-blue-700",
      attrs: {
        "href": list.slug
      }
    }, [_vm._v(_vm._s(list.name))])])]), _vm._v(" "), (list.description) ? _c('p', {
      staticClass: "text-gray-700 font-bold text-sm",
      domProps: {
        "textContent": _vm._s(list.description)
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text-gray text-sm"
    }, _vm._l((list.ideas), function(idea, index) {
      return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), (idea && ('name' in idea)) ? _c('span', [_vm._v(_vm._s(idea.name))]) : _vm._e()])
    }), 0)]) : _vm._e()])
  }), 0) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("All the Best Spots")])])
}]}

/***/ })
]),[83]);


// WEBPACK FOOTER //
// static/js/app.16a53b2a25169fdaab13.js